document.querySelectorAll('.standart-table__text table, .info-box__text table').forEach((table) => {
    if (table.parentElement && table.parentElement.classList.contains('table-wrapper')) {
        return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);
});
